<div class="modal-overlay" (click)="handleClose()">
  <div class="modal-container preview-modal" [class.image-preview-modal]="isImage()" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Aperçu : {{ doc.fileName }}</h2>
      <button class="close-btn" (click)="handleClose()">×</button>
    </div>

    <div class="modal-body preview-body" [class.image-preview]="isImage()">
      @if (isLoading()) {
        <div class="loading-state">Chargement de l'aperçu...</div>
      } @else if (error()) {
        <div class="alert alert-error">{{ error() }}</div>
      } @else if (safeUrl()) {
        @if (isImage()) {
          <div class="image-container">
            <img [src]="safeUrl()" [alt]="doc.fileName" class="preview-img">
          </div>
        } @else {
          <iframe [src]="safeUrl()" width="100%" height="100%" frameborder="0"></iframe>
        }
      }
    </div>
  </div>
</div>
